// src/App.js
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";



import { Tool } from "./pages/Tool";

function App() {
  return (

        <Router>
          <Routes>

            <Route path="/" element={<Tool />} />
           
          </Routes>
        </Router>

  );
}

export default App;
